import { createStore } from 'vuex'
import router from '../router'
import axios from 'axios'
import admin from './modules/admin.store'
import amdp from './modules/amdp.store'
import aut from './modules/aut.store'
import aio from './modules/aio.store'
import agm from './modules/agm.store'
import idr from './modules/idr.store'
import sandboxUnitTest from './modules/sandbox-unit-test.store'
import sandbox from './modules/sandbox.store'
import usage from './modules/usage.store'
import audience from './modules/audience.store'
import VuexPersistence from 'vuex-persist'
import { useToast, POSITION } from 'vue-toastification'
import { FAILSAFE_SCHEMA } from 'js-yaml'

const toast = useToast()

const vuexLocal = new VuexPersistence({
    //Specifiy the field(s) you want to persist on refesh. If empty, retains everything by default.
    modules: ['aut'],
    reducer: (state) => ({
        aut: {
            currentClass : state.aut.currentClass
        },        
        currentClient : state.currentClient, 
        toastNotif: state.toastNotif,
        forwardTo: state.forwardTo,
        redirectPath: state.redirectPath,
        paginationCache: state.paginationCache,
        selectedRegion: state.selectedRegion,
        selectedCloud: state.selectedCloud
    }),
    storage: window.localStorage
})
  
const initialState = () => {

    var environment =
        (function (h) {
            if (h.includes('preprod')) {
                return "pre_prod";
            } else if (h.includes('localhost')) {
                return "test";
            } else if (h.includes('dev')) {
                return "dev";
            } else {
                return (h.includes('staging')) ? "pre_prod" : "prod";
            }
        })(document.location.hostname);

    var authUrl = null;
    var aquacredUrl = null;
    var countsUrl = null;
    var dmsUrl = null;
    var docsUrl = null;
    var imdsUrl = null;
    var lakeviewUrl = null;
    var autMgmtUrl = null;
    var clientMgmtUrl = null;
    var pailUrl = null;
    var graphUrl = null;
    var surfaceUrl = null;
    var audsumUrl = null;
    var agentsUrl = null;
    var cookieDomain = null;
    var cognitoUrl = null;
    var cognitoClientId = null
    var cidLoading = false;
    var tagUrl = 'c901.aut-prod.aqfer.net';

    switch (environment) {
        case 'dev':
            cookieDomain = 'api-dev.aqfer.net'
            cognitoUrl = 'https://us-west-2avbse9dfq-dev.auth.us-west-2.amazoncognito.com/oauth2/authorize';
            cognitoClientId = 'plhrmkh1a5putvho9rj72anbu';
            authUrl = 'https://auth.api-dev.aqfer.net'
            aquacredUrl = 'https://aquacred-test.api-dev.aqfer.net'
            countsUrl = 'https://counts.api-dev.aqfer.net'
            docsUrl = 'https://docs-dev.aqfer.net'
            dmsUrl = 'https://dms.api-dev.aqfer.net'
            lakeviewUrl = 'https://lakeview.api-dev.aqfer.net'
            imdsUrl = 'https://imds.api-dev.aqfer.net'
            autMgmtUrl = 'https://atm-config.api-dev.aqfer.net'
            clientMgmtUrl = 'https://client-mgmt.api-dev.aqfer.net'
            pailUrl = 'https://pail.api-dev.aqfer.net'
            graphUrl = 'https://graph.api-dev.aqfer.net'
            surfaceUrl = 'https://surface.api-dev.aqfer.net'
            audsumUrl = 'https://audsum.api-dev.aqfer.net'
            agentsUrl='https://agents.ai-dev.aqfer.net'
            break;
        case 'test':
            cookieDomain = 'api-dev.aqfer.net'
            cognitoUrl = 'https://us-west-2avbse9dfq-dev.auth.us-west-2.amazoncognito.com/oauth2/authorize';
            cognitoClientId = 'plhrmkh1a5putvho9rj72anbu';
            authUrl = 'http://localhost:3000/auth'
            aquacredUrl = 'http://localhost:3000/aquacred'
            countsUrl = 'http://localhost:3000/counts'
            docsUrl = 'http://localhost:3000/docs'
            dmsUrl = 'http://localhost:3000/dms'
            lakeviewUrl = 'http://localhost:3000/lakeview'
            imdsUrl = 'http://localhost:3000/imds'
            autMgmtUrl = 'http://localhost:3000/mgmt'
            clientMgmtUrl = 'http://localhost:3000/client-mgmt'
            pailUrl = 'http://localhost:3000/pail'
            graphUrl = 'http://localhost:3000/graph'
            surfaceUrl = 'http://localhost:3000/surface'
            audsumUrl = 'https://localhost:3000/audsum'
            agentsUrl='http://localhost:3000/agents'
            break;
        case 'pre_prod':
            cookieDomain = 'app-staging.aqfer.net'
            cognitoUrl = 'https://aqfer-staging.auth.us-west-2.amazoncognito.com/oauth2/authorize';
            cognitoClientId = '50q62gjqn5f4si8ak54fgtjmv4';
            authUrl = 'https://auth.api-preprod.aqfer.net'
            aquacredUrl = 'https://aquacred.api-preprod.aqfer.net'
            countsUrl = 'https://counts.api-preprod.aqfer.net'
            dmsUrl = 'https://dms.api-preprod.aqfer.net'
            docsUrl = 'https://docs-staging.aqfer.net'
            lakeviewUrl = 'https://lakeview.api-preprod.aqfer.net'
            imdsUrl = 'https://imds.api-preprod.aqfer.net'
            autMgmtUrl = 'https://atm-config.api-preprod.aqfer.net'
            clientMgmtUrl = 'https://client-mgmt.api-preprod.aqfer.net'
            pailUrl = 'https://pail.api-preprod.aqfer.net'
            graphUrl = 'https://graph.api-preprod.aqfer.net'
            surfaceUrl = 'https://surface.api-preprod.aqfer.net'
            audsumUrl = 'https://audsum.api-preprod.aqfer.net'
            agentsUrl='https://agents.ai-preprod.aqfer.net'
            break;
        default:
            cookieDomain = 'app.aqfer.net'
            cognitoUrl = 'https://aqfer.auth.us-west-2.amazoncognito.com/oauth2/authorize';
            cognitoClientId = '53nfrram2ttnq23vmrvpcunmji';
            authUrl = 'https://auth.api.aqfer.net'
            aquacredUrl = 'https://aquacred.api.aqfer.net'
            countsUrl = 'https://counts.api.aqfer.net'
            dmsUrl = 'https://dms.api.aqfer.net'
            docsUrl = 'https://docs.aqfer.net'
            lakeviewUrl = 'https://lakeview.api.aqfer.net'
            imdsUrl = 'https://imds.api.aqfer.net'
            autMgmtUrl = 'https://atm-config.api.aqfer.net'
            clientMgmtUrl = 'https://client-mgmt.api.aqfer.net'
            pailUrl = 'https://pail.api.aqfer.net'
            graphUrl = 'https://graph.api.aqfer.net'
            surfaceUrl = 'https://surface.api.aqfer.net'
            audsumUrl = 'https://audsum.api.aqfer.net'
            agentsUrl='https://agents.ai.aqfer.net'
            break;
    }


    return {
        environment: environment,
        cookieDomain:cookieDomain,
        cognitoUrl: cognitoUrl,
        cognitoClientId: cognitoClientId,
        authUrl: authUrl,
        countsUrl: countsUrl,
        dmsUrl: dmsUrl,
        docsUrl: docsUrl,
        lakeviewUrl: lakeviewUrl,
        imdsUrl: imdsUrl,
        autMgmtUrl: autMgmtUrl,
        clientMgmtUrl: clientMgmtUrl,
        pailUrl: pailUrl,
        surfaceUrl: surfaceUrl,
        defaultSurfaceUrl:surfaceUrl,
        audsumUrl: audsumUrl,
        aquacredUrl: aquacredUrl,
        discoveredServices: [],
        defaultUrls: {
            audsum: audsumUrl,
            pail: pailUrl,
            surface: surfaceUrl,
            agents: agentsUrl,
            aquacred: aquacredUrl,
            graph: graphUrl
        },
        graphServiceUrl: graphUrl,
        pailVersion: 'v1',
        selectedRegion: null,
        selectedCloud: null,
        availableRegions: [],
        endpointsByCloudRegion: {},
        serviceEndpointsByRegion: {},
        tagUrl: tagUrl,
        currentUser: null,
        currentClient: null,
        clients: null,
        docsToken: null,
        loading: false,
        restrictedAccess: false,
        collapseNav: false,
        darkMode: JSON.parse(localStorage.getItem('darkMode') || 'false'),
        showModal: false,
        modalComponent: null,
        modalData: null,
        toastNotif: true,
        forwardTo: null,
        redirectPath: null,
        datatableCache:{},
        paginationCache:{},
        activeTab:null,
        breadcrumbs:[],
        navItems: [
            {
                name: 'Home',
                icon: 'home',
                route: '/'
            }, {
                name: 'Admin',
                icon: 'unlock',
                roles: ["aqfer_admin","aqfer_manager","aqfer_user","client_admin"],
                children: [{
                    name: 'Users',
                    icon: 'user-group',
                    route: '/admin/users',
                    roles: ['aqfer_admin', 'aqfer_manager', 'client_admin'],
                }, {
                    name: 'Clients',
                    icon: 'users-gear',
                    route: '/admin/clients',
                    roles: ['aqfer_admin', 'aqfer_manager'],
                }, {
                    name: 'Entitlement Usage (beta)',
                    icon: 'chart-column',
                    route: '/admin/usage',
                    roles: ['aqfer_admin','aqfer_manager','client_admin','aqfer_user'],
                    domainSpecific: "@aqfer.com",
                },{
                    name: 'Infrastructure Usage',
                    icon: 'chart-column',
                    route: '/admin/infrastructure-usage',
                    roles: ['aqfer_admin','aqfer_manager','client_admin', 'aqfer_user'],
                    domainSpecific: "@aqfer.com",
                },
                {
                    name: 'AI Usage',
                    icon: 'brain',
                    route: '/admin/ai-usage/agents',
                    roles: ['aqfer_admin','aqfer_manager','client_admin','aqfer_user'],
                    domainSpecific: "@aqfer.com",
                },
                {
                    name: 'Reports',
                    icon: 'clipboard-list',
                    children: [                        
                        {
                            name: 'Sign Ins',
                            route: '/admin/reports/sign-ins'
                        },
                    ],
                    roles: ['aqfer_admin', 'aqfer_manager', 'client_admin'],
                }, {
                    name: 'Dashboards',
                    icon: 'chart-line',
                    route: '/admin/dashboards',
                    roles: ['aqfer_admin','aqfer_user','client_admin'],
                    // aqfer_manager role can be granted, but this tab is deprecated
                },
                {
                    name: 'Tokens',
                    icon: 'key',
                    route: '/admin/tokens',
                    roles: ['aqfer_admin','aqfer_manager','client_admin'],
                },
                {
                    name: 'EncryptedURLs',
                    icon: 'link',
                    route: '/admin/encrypted-urls',
                    roles: ['aqfer_admin', 'aqfer_manager'],
                    domainSpecific: "@aqfer.com",
                },
                {
                    name: 'Products',
                    icon: 'cubes',
                    route: '/admin/products',
                    roles: ['aqfer_admin', 'aqfer_manager'],
                    //environmentRestrictions: ['dev','pre_prod'],
                    domainSpecific: "@aqfer.com",
                }, 
                {
                    name: 'Entitlements',
                    icon: 'id-card',
                    route: '/admin/entitlements',
                    roles: ['aqfer_admin', 'aqfer_manager'],
                    //environmentRestrictions: ['dev','pre_prod'],
                    domainSpecific: "@aqfer.com",
                },
                {
                    name: 'Template Jobs',
                    icon: 'file',
                    route: '/admin/template-jobs',
                    roles: ['aqfer_admin','aqfer_manager','client_admin'],
                    domainSpecific: "@aqfer.com",
                },
                {
                    name: 'Documentations',
                    icon: 'book',
                    route: '/admin/documentations',
                    roles: ['aqfer_admin', 'aqfer_manager'],
                    domainSpecific: "@aqfer.com",
                },
            ]
            },
            {
                name: 'PAICE',
                icon: 'robot',
                route: '/:cid/paice',
                roles: ['aqfer_admin', 'aqfer_manager', 'client_admin'],
                domainSpecific: "@aqfer.com",
            },
            {
                name: 'aUT',
                featureId: 'TAG_MANAGER',
                icon: 'tag',
                optional: true,
                children: [                        
                    {
                        name: 'Settings',
                        icon: 'gear',
                        route: '/:cid/aut/settings',
                    },
                    {
                        name: 'Classes',
                        icon: 'layer-group',
                        route: '/:cid/aut/classes'    
                    },
                    {
                        name: 'Certificates',
                        icon: 'file-lines',
                        route: '/:cid/aut/certificates',
                    },
                    {
                        name: 'Credentials',
                        icon: 'key',
                        route: '/:cid/aut/credentials',
                    },
                    {
                        name: "Tag Template Library",
                        icon: 'user-tag',
                        route: '/:cid/aut/tag-templates'
                    },
                    {
                        name: "Initiators",
                        icon: 'database',
                        route: '/:cid/aut/initiators',
                        roles: ['aqfer_admin', 'aqfer_manager']
                    },
                    {
                        name: "Initiator Fields",
                        icon: 'list',
                        route: '/:cid/aut/initiator-fields',
                        roles: ['aqfer_admin', 'aqfer_manager']
                    },
                    {
                        name: "Browse Tag Templates",
                        icon: 'tags',
                        route: '/:cid/aut/browse-tag-templates'
                    },
                    {
                        name: "Generate Tag",
                        icon: 'regular fa-circle-play',
                        route: '/:cid/aut/generate-tag'
                    },
                    {
                        name: "Configure Hosts",
                        icon: 'globe',
                        route: '/:cid/aut/configure-hosts'
                    },
                    {
                        name: 'Reports',
                        icon: 'clipboard-list',
                        route: '/:cid/aut/reports',
                    }, 
                    {
                        name: 'Dashboard',
                        icon: 'chart-line',
                        route: '/:cid/aut/dashboards'
                    },
                    {
                        name: 'Usage',
                        icon: 'chart-column',
                        route: '/:cid/aut/usage',
                    }]
            }, {
                name: 'aMDP',
                featureId: 'DATA_LAKE',
                icon: 'database',
                optional: true,
                children: [{
                    name: 'Named Queries',
                    icon: 'clipboard-question',
                    route: '/:cid/amdp/queries',
                },
                {
                    name: 'Map My Data',
                    icon: 'arrows-turn-to-dots',
                    roles: ['aqfer_admin', 'aqfer_manager', 'aqfer_user', 'client_admin'],
                    route: '/:cid/amdp/map-my-data',
                    featureItemID: "map_my_data",
                    domainSpecific: ["@aqfer.com", "Y3dpbGxpYW1zODdAaG90bWFpbC5jb20=", "b2RhbkBhY3hpb20uY29t", "QGNsZWFyY2hhbm5lbC5jb20K", "YXlsb3JAYWN4aW9tLmNvbQ==", "aGFuZzFAYWN4aW9tLmNvbQ==", "YWxvZ2hAYWN4aW9tLmNvbQ=="],
                },
                {
                    name: 'Talk 2 My Data',
                    icon: 'walkie-talkie',
                    roles: ['aqfer_admin', 'aqfer_manager', 'aqfer_user', 'client_admin'],
                    route: '/:cid/amdp/talk-to-my-data',
                    featureItemID: "talk_2_my_data",
                    domainSpecific: ["@aqfer.com", "Y3dpbGxpYW1zODdAaG90bWFpbC5jb20=", "b2RhbkBhY3hpb20uY29t", "QGNsZWFyY2hhbm5lbC5jb20K", "YXlsb3JAYWN4aW9tLmNvbQ==", "aGFuZzFAYWN4aW9tLmNvbQ==", "YWxvZ2hAYWN4aW9tLmNvbQ=="],
                },
                {
                    name: 'Credentials',
                    icon: 'key',
                    route: '/:cid/amdp/credentials',
                },
                {
                    name: 'Jobs',
                    icon: 'list-check',
                    route: '/:cid/amdp/:sandboxId/jobs',
                    sandboxTypes: ['prod','prodV2']
                },
                {
                    name: 'Dashboards',
                    icon: 'chart-line',
                    route: '/:cid/amdp/jobs-dashboard',
                    featureItemID: "jobs_dashboards"
                },
                {
                    name: 'Usage',
                    route: '/:cid/amdp/usage',
                    icon: 'chart-column',
                },
                {
                    name: 'Sandbox',
                    icon: 'box-open',
                    children: [{
                        name: 'Unit Test',
                        route: '/:cid/amdp/sandbox/unit-test',
                        roles: ['nobody']
                    },
                    {
                        name: 'Management',
                        route:'/:cid/amdp/sandboxes',
                        roles: ['aqfer_admin', 'aqfer_manager']
                    },
                    {
                        name: 'Users',
                        route:'/:cid/amdp/sandbox/users',
                        roles: ['aqfer_admin', 'aqfer_manager', 'client_admin']
                    },{
                        
                        name: 'Job List',
                        route:'/:cid/amdp/sandbox/:sandboxId/jobs',
                        sandboxTypes: ['dev']
                    },{
                        name: 'Promotions',
                        route:'/:cid/amdp/sandbox/:sandboxId/promotions',
                        stateConditional: 'sandbox/hasProdV2Sandbox',
                        sandboxTypes: ['prodV2']
                    },{
                        name: 'File Browser',
                        route:'/:cid/amdp/:sandboxId/file-browser',
                        roles: ['aqfer_admin', 'aqfer_manager'],
                        domainSpecific: "@aqfer.com",
                        sandboxTypes: ['dev']
                    },
                    {
                        name: 'Credentials',
                        route: '/:cid/amdp/:sandboxId/credentials',
                        sandboxTypes: ['dev']
                    },
                    /* uncomment once cid specific template jobs migrated to lakeview
                    {
                        name: 'Job Templates',
                        route: '/:cid/job-templates',
                        domainSpecific: "@aqfer.com",
                    }, */
                ]
                },
                {
                    name: 'Audience Manager',
                    icon: 'users',
                    route: '/:cid/amdp/audiences',
                    featureItemID: "audience_manager",
                },
                {
                    name: 'Configurator (beta)',
                    icon: 'wrench',
                    route: '/:cid/amdp/flow-set',
                    domainSpecific: "@aqfer.com",
                    environmentRestrictions: ['dev','pre_prod'],
                },
                {
                    name: 'AE Demo',
                    icon: 'gears',
                    route: '/:cid/amdp/ae-demo',
                    domainSpecific: "@aqfer.com",
                    environmentRestrictions: ['prod'],
                },]
            }, {
                name: 'aGM',
                icon: 'circle-nodes',
                featureId: "AGM",
                optional: true,
                children: [{
                    name: 'Dashboards',
                    route: '/agm/dashboards',
                    icon: 'chart-line',
                },{
                    name: 'IDR',
                    icon: 'list-check',
                    route:'/:cid/agm/sandbox/:sandboxId/jobs',
                    sandboxTypes: ['dev'],
                },{
                    name: "Deployments",
                    icon: 'wrench',
                    route:'/:cid/agm/sandbox/:sandboxId/deployments',
                    sandboxTypes: ['dev'],
                    domainSpecific: "@aqfer.com",
                },
                {
                    name: 'Graph Report',
                    icon: 'chart-column',
                    route: '/:cid/agm/graph-report-v2',
                },
                {
                    name: 'Graph Visualizer',
                    icon: 'share-nodes',
                    route: '/:cid/agm/graph-visualizer',
                    domainSpecific: "@aqfer.com",
                },
                {
                    name: 'Graph Curation',
                    icon: 'project-diagram',
                    route: '/:cid/agm/graph-curation', 
                    roles: ['aqfer_admin', 'aqfer_manager'],
                    domainSpecific: "@aqfer.com",
                },
                {
                    name: 'Graph My Data',
                    icon: 'network-wired',
                    route: '/:cid/agm/graph-my-data',
                    roles: ['aqfer_admin', 'aqfer_manager', 'aqfer_user', 'client_admin'],
                    domainSpecific: "@aqfer.com",
                },
            ]
            }, {
                name: 'aIO',
                icon: 'arrow-right-arrow-left',
                featureId: "AIO",
                optional: true,
                children: [{
                    name: 'Dashboards',
                    route: '/:cid/aio/dashboards',
                    icon: 'chart-line',
                },{
                    name: 'Usage',
                    route: '/:cid/aio/usage',
                    icon: 'chart-column',
                },{
                    name: 'Handler Sandbox',
                    icon: 'box-open',
                    route: '/:cid/aio/:sandboxId/handler-sandbox',
                    featureItemID: "aio_sandbox_beta",
                    sandboxTypes: ['dev'],
                    domainSpecific: "@aqfer.com",
                }]
            },  {
                name: 'Apps',
                icon: 'laptop-code',
                children: [{
                    name: 'Demo 1',
                    route: '/apps/demo1',
                }, {
                    name: 'Demo 2',
                    route: '/apps/demo2',
                }]
            }

        ]
    }
};

const store = createStore({
    state: initialState(),
    mutations: {
        setInitialState(state) {
            state = initialState()
        },
        setLoading(state, loading) {
            state.loading = loading
        },
        setRestrictedAccess(state, accessState) {
            state.restrictedAccess = accessState;
        },
        setCollapseNav(state, collapseNav) {
            state.collapseNav = collapseNav
        },
        setDarkMode(state, darkMode) {
            state.darkMode = darkMode;
            localStorage.setItem('darkMode', JSON.stringify(darkMode));
            if (darkMode) {
                document.body.classList.add('dark-mode');
            } else {
                document.body.classList.remove('dark-mode');
            }
        },
        setShowModal(state, showModal) {
            state.showModal = showModal
        },
        setModalComponent(state, modalComponent) {
            state.modalComponent = modalComponent
        },
        setModalData(state, modalData) {
            state.modalData = modalData
        },
        setModalValue(state, modalValue) {
            state.modalValue = modalValue;
        },
        
        setAccessToken(state, accessToken) {
            state.accessToken = accessToken
        },
        setCurrentUser(state, currentUser) {
            state.currentUser = currentUser
        },
        setCurrentClient(state, currentClient) {
            state.currentClient = currentClient
        },
        setClients(state, clients) {
            state.clients = clients
        },
        setDocsToken(state, docsToken) {
            state.docsToken = docsToken
        },
        setCidLoading(state, cidLoading) {
            state.cidLoading = cidLoading
        },        
        setForwardTo(state, forwardTo) {
            state.forwardTo = forwardTo
        },
        setRedirectPath(state, redirectPath) {
            state.redirectPath = redirectPath
        },
        setDatatableCache(state, datatableCache) {
            state.datatableCache = datatableCache
        },
        setPaginationCache(state, paginationCache) {
            state.paginationCache = paginationCache
        },
        setActiveTab(state,activeTab){
            state.activeTab = activeTab
        },
        setBreadcrumbs(state, breadcrumbs) {
            state.breadcrumbs = breadcrumbs;
        },
        setDiscoveredServices(state, services) {
            state.discoveredServices = services;
        },
        setAudsumUrl(state, url) {
            state.audsumUrl = url;
        },
        setPailUrl(state, url) {
            state.pailUrl = url;
        },
        setPailVersion(state, version) {
            state.pailVersion = version;
        },
        setSurfaceUrl(state, url) {
            state.surfaceUrl = url;
        },
        setAgentsUrl(state, url) {
            state.agentsUrl = url;
        },
        setAquacredUrl(state, url) {
            state.aquacredUrl = url;
        },
        setGraphServiceUrl(state, url) {
            state.graphServiceUrl = url;
        },
        setSelectedRegion(state, region) {
            state.selectedRegion = region;
        },
        setSelectedCloud(state, cloud) {
            state.selectedCloud = cloud;
        },
        setAvailableRegions(state, regions) {
            state.availableRegions = regions;
        },
        setEndpointsByCloudRegion(state, map) {
            state.endpointsByCloudRegion = map || {};
        },
        setServiceEndpointsByRegion(state, map) {
            state.serviceEndpointsByRegion = map;
        },
    },
    actions: {
        setInitialState({ commit }) {
            commit('setInitialState')
        },
        setLoading({ commit }, loading) {
            commit('setLoading', loading)
        },
        setRestrictedAccess({commit}, accessState) {
           commit('setRestrictedAccess', accessState)
        },
        showModal({ commit }, {component, data, value}) {
            commit('setModalComponent', component)
            commit('setModalData', data)
            commit('setModalValue', value )
            commit('setShowModal', true)
        },
        hideModal({ commit }) {
            commit('setShowModal', false)
        },
        setModalComponent({ commit }, modalComponent) {
            commit('setModalComponent', modalComponent)
        },
        setModalData({ commit }, modalData) {
            commit('setModalData', modalData)
        },
        setCollapseNav({ commit }, collapseNav) {            
            commit('setCollapseNav', collapseNav)
        },
        setDarkMode({ commit }, darkMode) {
            commit('setDarkMode', darkMode)
        },
        toggleDarkMode({ commit, state }) {
            commit('setDarkMode', !state.darkMode)
        },
        setModalValue({ commit }, modalValue) {            
            commit('setModalValue', modalValue)
        },
        setAccessToken({ commit }, accessToken) {
            commit('setAccessToken', accessToken)
        },
        setForwardTo({ commit }, forwardTo) {
            commit('setForwardTo', forwardTo)
        },
        setRedirectPath({ commit }, redirectPath) {
            commit('setRedirectPath', redirectPath)
        },
        setDatatableCache({ commit }, datatableCache) {
            commit('setDatatableCache', datatableCache)
        },
        setPaginationCache({commit}, paginationCache) {
            commit('setPaginationCache', paginationCache)
        },
        setActiveTab({ commit }, activeTab) {
            commit('setActiveTab', activeTab)
        },
        setBreadcrumbs({ commit }, breadcrumbs) {
            commit('setBreadcrumbs', breadcrumbs)
        },
        async setServiceEndpoints({ state, commit }, { clientId, region, cloud }) {
            const MANAGED_SERVICES = ['audsum', 'pail', 'surface', 'agents', 'aquacred', 'graph'];
            const MUTATION_MAP = {
                audsum: 'setAudsumUrl',
                pail: 'setPailUrl',
                surface: 'setSurfaceUrl',
                agents: 'setAgentsUrl',
                aquacred: 'setAquacredUrl',
                graph: 'setGraphServiceUrl',
            };

            let discoveredServices = [];
            commit('setDiscoveredServices', []);
            commit('setEndpointsByCloudRegion', {});
            commit('setSelectedCloud', null);
            commit('setAvailableRegions', []);
            commit('setSelectedRegion', null);
            commit('setServiceEndpointsByRegion', {});

            const applyDefaultUrls = () => {
                for (const name of MANAGED_SERVICES) {
                    commit(MUTATION_MAP[name], state.defaultUrls[name]);
                }
            };

            const normalizeCloudKey = (svc) => {
                const raw = svc.cloud ?? svc.cloud_provider ?? svc.cloudProvider;
                if (raw == null || String(raw).trim() === '') return '';
                return String(raw).trim().toLowerCase();
            };

            try {
                const response = await axios.get(state.clientMgmtUrl + `/v1/clients/${clientId}/service_deployments`, {
                    headers: {
                        Authorization: `Bearer ${state.accessToken}`,
                    },
                });
                const services = response.data || [];

                const byCloud = {};

                for (const svc of services) {
                    if (svc.status !== 'ENABLED' || !svc.endpoint) continue;
                    if (!MANAGED_SERVICES.includes(svc.service)) continue;

                    const cloudKey = normalizeCloudKey(svc);
                    const rgn = svc.region || 'default';
                    if (!byCloud[cloudKey]) byCloud[cloudKey] = {};
                    if (!byCloud[cloudKey][rgn]) byCloud[cloudKey][rgn] = {};
                    byCloud[cloudKey][rgn][svc.service] = svc.endpoint;
                }

                const cloudKeys = Object.keys(byCloud).sort();
                if (!cloudKeys.length) {
                    throw new Error('No enabled service deployments');
                }

                commit('setEndpointsByCloudRegion', byCloud);

                let selectedCloud = cloud != null ? cloud : state.selectedCloud;
                if (selectedCloud == null || !Object.prototype.hasOwnProperty.call(byCloud, selectedCloud)) {
                    selectedCloud = cloudKeys[0];
                }
                commit('setSelectedCloud', selectedCloud);

                const byRegion = byCloud[selectedCloud] || {};
                commit('setServiceEndpointsByRegion', byRegion);
                const regionList = Object.keys(byRegion).sort();
                commit('setAvailableRegions', regionList);

                let selectedRegion = region || state.selectedRegion;
                if (!selectedRegion || !byRegion[selectedRegion]) {
                    selectedRegion = regionList.length ? regionList[0] : null;
                }
                commit('setSelectedRegion', selectedRegion);

                const regionEndpoints = (selectedRegion && byRegion[selectedRegion]) || {};
                for (const name of MANAGED_SERVICES) {
                    const url = regionEndpoints[name] || state.defaultUrls[name];
                    commit(MUTATION_MAP[name], url);
                    if (regionEndpoints[name]) {
                        discoveredServices.push(name);
                    }
                }
            } catch (error) {
                console.error('Error fetching service endpoints:', error);
                commit('setEndpointsByCloudRegion', {});
                commit('setSelectedCloud', null);
                commit('setAvailableRegions', []);
                commit('setSelectedRegion', null);
                commit('setServiceEndpointsByRegion', {});
                applyDefaultUrls();
            } finally {
                commit('setPailVersion', state.pailUrl === state.defaultUrls.pail ? 'v1' : 'v2');
                commit('setDiscoveredServices', [...discoveredServices]);
                console.log(`%cDiscovered services for client ${clientId}: ${discoveredServices}`, "color:green;");
            }
        },
        switchCloud({ state, commit, dispatch }, cloud) {
            const MANAGED_SERVICES = ['audsum', 'pail', 'surface', 'agents', 'aquacred', 'graph'];
            const MUTATION_MAP = {
                audsum: 'setAudsumUrl',
                pail: 'setPailUrl',
                surface: 'setSurfaceUrl',
                agents: 'setAgentsUrl',
                aquacred: 'setAquacredUrl',
                graph: 'setGraphServiceUrl',
            };

            const byCloud = state.endpointsByCloudRegion || {};
            if (!Object.prototype.hasOwnProperty.call(byCloud, cloud)) {
                return;
            }

            commit('setSelectedCloud', cloud);
            const byRegion = byCloud[cloud] || {};
            commit('setServiceEndpointsByRegion', byRegion);
            const regionList = Object.keys(byRegion).sort();
            commit('setAvailableRegions', regionList);

            let selectedRegion = state.selectedRegion;
            if (!selectedRegion || !byRegion[selectedRegion]) {
                selectedRegion = regionList.length ? regionList[0] : null;
            }
            commit('setSelectedRegion', selectedRegion);

            const regionEndpoints = (selectedRegion && byRegion[selectedRegion]) || {};
            const discoveredServices = [];
            const fallbackServices = [];

            for (const name of MANAGED_SERVICES) {
                const url = regionEndpoints[name] || state.defaultUrls[name];
                commit(MUTATION_MAP[name], url);
                if (regionEndpoints[name]) {
                    discoveredServices.push(name);
                } else {
                    fallbackServices.push(name);
                }
            }
            commit('setPailVersion', state.pailUrl === state.defaultUrls.pail ? 'v1' : 'v2');
            commit('setDiscoveredServices', [...discoveredServices]);
            console.log(`%cDiscovered services for client ${state.currentClient && state.currentClient.cid}: ${discoveredServices}`, "color:green;");

            const cloudLabel = cloud === '' ? 'default' : cloud.toUpperCase();
            if (fallbackServices.length && fallbackServices.length < MANAGED_SERVICES.length) {
                dispatch('addToast', {
                    message: `Cloud ${cloudLabel}, region ${selectedRegion || 'n/a'}. Some services use default endpoints: ${fallbackServices.join(', ')}.`,
                    type: 'warning',
                });
            } else if (fallbackServices.length === MANAGED_SERVICES.length) {
                dispatch('addToast', {
                    message: `No endpoints for ${cloudLabel} / ${selectedRegion || 'n/a'}. Using defaults.`,
                    type: 'warning',
                });
            } else {
                dispatch('addToast', {
                    message: `Switched to ${cloudLabel}${selectedRegion ? `, ${selectedRegion}` : ''}.`,
                    type: 'success',
                });
            }
        },
        switchRegion({ state, commit, dispatch }, region) {
            const MANAGED_SERVICES = ['audsum', 'pail', 'surface', 'agents', 'aquacred', 'graph'];
            const MUTATION_MAP = {
                audsum: 'setAudsumUrl',
                pail: 'setPailUrl',
                surface: 'setSurfaceUrl',
                agents: 'setAgentsUrl',
                aquacred: 'setAquacredUrl',
                graph: 'setGraphServiceUrl',
            };

            commit('setSelectedRegion', region);
            const regionEndpoints = state.serviceEndpointsByRegion[region] || {};
            const fallbackServices = [];
            const discoveredServices = [];

            for (const name of MANAGED_SERVICES) {
                const url = regionEndpoints[name] || state.defaultUrls[name];
                commit(MUTATION_MAP[name], url);
                if (regionEndpoints[name]) {
                    discoveredServices.push(name);
                } else {
                    fallbackServices.push(name);
                }
            }
            commit('setPailVersion', state.pailUrl === state.defaultUrls.pail ? 'v1' : 'v2');
            commit('setDiscoveredServices', [...discoveredServices]);
            console.log(`%cDiscovered services for client ${state.currentClient.cid}: ${discoveredServices}`, "color:green;");
            if (fallbackServices.length && fallbackServices.length < MANAGED_SERVICES.length) {
                dispatch('addToast', {
                    message: `Region switched to ${region}. The following services are not available in this region and will use default endpoints: ${fallbackServices.join(', ')}.`,
                    type: 'warning',
                });
            } else if (fallbackServices.length === MANAGED_SERVICES.length) {
                dispatch('addToast', {
                    message: `No service endpoints are configured for region ${region}. Using default endpoints.`,
                    type: 'warning',
                });
            } else {
                dispatch('addToast', {
                    message: `Region switched to ${region}. All services are available.`,
                    type: 'success',
                });
            }
        },
        onClientChange() {
            this.dispatch('amdp/onClientChange')
            this.dispatch('aut/onClientChange')
            this.dispatch('sandbox/onClientChange')
            this.dispatch('aio/onClientChange')
            this.dispatch('audience/onClientChange')
            this.dispatch('admin/onClientChange')
        },
        afterClientChange() {
            this.dispatch('sandbox/afterClientChange')
        },
        setCurrentClient({ commit }, clientId) {
            commit('setCidLoading', true)
            this.dispatch('onClientChange')
            this.dispatch('fetchCurrentClient',clientId)
            .then(async (response) => {
                commit('setCurrentClient', response.data)
                commit('setCidLoading', false);
                await this.dispatch('sandbox/fetchSandboxes', clientId)
                //this.dispatch("updatePathParams", {cid: clientId});
             })
            
        },
        // Action for views to subscribe when cid changed from sidebar dropdown
        setCidChangeTrigger({ commit } , trigger) {
            commit('setCidChangeTrigger', trigger);
        },
        updatePathParams({ commit }, newParams) {
            console.log("inside update path params");
            const currentParams = router.currentRoute.params;  
            const mergedParams = { ...currentParams, ...newParams };  
            // When router is not supplied path or name,
            // it simply tries to update current route with new params or query
            // Almost everything is optional.
            router.push({ params: mergedParams });
        },
        async fetchCurrentClient({state},clientId){
            return axios.get(state.clientMgmtUrl + `/v1/cids/${clientId}`, {
                headers: {
                    Authorization: `Bearer ${state.accessToken}`,
                },
            })
        },
        addToast({commit}, {type, message, config}) {
            if(!config)
            config = { 
                            position: POSITION.BOTTOM_CENTER,
                            transition: "Vue-Toastification__fade",
                            timeout: 2400
                        };
             
            if(type == "error") {
                toast.error(message, config);
            } 
            else if(type == "info") {
                toast.info(message, config);
            } 
            else if(type == "warning") {
                toast.warning(message, config);
            } 
            else if(type == "success"){
                toast.success(message, config);
            }
            else {
                toast.info(message, config);
            }
        },
        dismissToast({commit}, toastId) {
            toast.dismiss(toastId);
        },
        cidLogin({ state }, cid) {
            state.toastNotif = true;
            localStorage.setItem('cidLogin', cid);
            const successUrl = encodeURIComponent(window.location.origin);
            window.location.href = `${state.authUrl}/v1/cids/${encodeURIComponent(cid)}/login?success_redirect_url=${successUrl}`;
        },
        login({ state }, method) {
            state.toastNotif = true;
            const failureUrl = encodeURIComponent(window.location.href)
            const successUrl = encodeURIComponent(window.location.origin)
            const gConfigUrl = `${state.authUrl}/v1/config?success_redirect_url=${successUrl}&failure_redirect_url=${failureUrl}`

            axios(gConfigUrl).then((response) => {
                const gConfig = response.data.result;
                if (method == 'google') {
                    const returnPath = `${state.authUrl}/v1/openid-connect`
                    const googleUrl = `https://accounts.google.com/o/oauth2/v2/auth?client_id=${gConfig.clientId}&response_type=code&scope=openid%20email&redirect_uri=${returnPath}&login_hint=sub&state=${gConfig.state}`
                    //console.log(googleUrl)
                    window.location.href = googleUrl;
                } else { //use cognito
                    const returnPath = `${state.authUrl}/v1/cognito-oauth`;
                    let cognitoUrl = state.cognitoUrl
                    cognitoUrl += `?client_id=${state.cognitoClientId}`;
                    cognitoUrl += `&response_type=code`;
                    cognitoUrl += `&scope=${encodeURIComponent('openid')}`;
                    cognitoUrl += `&redirect_uri=${encodeURIComponent(returnPath)}`;
                    cognitoUrl += `&state=${encodeURIComponent(gConfig.state)}`;
                    window.location.href = cognitoUrl;
                }
            });
        },
        handleUserData({ commit }, userData) {
            if (userData.email) {
                const previousUser = localStorage.getItem('recentPagesUser');
                if (previousUser && previousUser !== userData.email) {
                    localStorage.removeItem('recentPages');
                }
                localStorage.setItem('recentPagesUser', userData.email);
                commit('setCurrentUser', userData)
            }
        },
        async handleClientList({ state, commit }, params) {  
            let clientsData = params.clientsData;
            let routeParams = params.routeParams;  
            if (clientsData) {
                commit('setClients', clientsData);

                let cid = clientsData[0].cid
                if(routeParams.cid && clientsData.some(client => client.cid === routeParams.cid)) {
                    cid = routeParams.cid;
                } else if(state.currentClient && clientsData.some(client => client.cid === state.currentClient.cid)){
                    cid = state.currentClient.cid;
                }
                                
                // set service endpoints in initial load
                await this.dispatch('setServiceEndpoints', { clientId: cid })
                
                //getting detailed view of client
                this.dispatch('setCurrentClient', cid)
            }
        },
        handleDocsAuthData({ commit }, docsAuthData) {
            if (docsAuthData.docsToken) {
                commit('setDocsToken', docsAuthData.docsToken)
            }
        },
        logout({ state, commit }) {
            commit('setInitialState')
            axios.post(state.authUrl + '/v1/logout', null, {
                headers: {
                    'Authorization': `Bearer ${state.accessToken}`
                }
            })
            .finally((res) => {
                const {$cookies} = router.app.config.globalProperties
                //access-token is not removed properly so restting to empty and expiring the date
                $cookies.set('access-token','',new Date().toUTCString(),"/",state.cookieDomain,null,'Strict')
                $cookies.remove('authExpireTime', null)
                const cidLogin = localStorage.getItem('cidLogin')
                router.push(cidLogin ? `/${encodeURIComponent(cidLogin)}/login` : '/login')
            })
        },
        whoAmICheck({state}){ 
            return axios.get(state.authUrl + '/v1/who-am-i', {
                headers: {
                    'Authorization': `Bearer ${state.accessToken}`
                }
            })
            .then((res) => {
                //From Who-ma-i getting Token expire time and creating new cookie variable
                if(new Date(res.data.token_expires_at).getTime()<new Date().getTime() && store.state.environment != 'test'){
                    store.dispatch('setRedirectPath', window.location.pathname)
                    store.dispatch('logout');
                    return
                }
                return res;
            })
            .catch((error) => {
                console.error(error)
            })
        },
        getBlogData(){
            return  axios.get('https://aqfer.com/wp-json/wp/v2/posts')
            .then(response => {
                return response.data
            });
        },
        async getHelpjuiceURL({rootState}) {
            return axios.get(rootState.defaultSurfaceUrl + "/v2/getPortalHelpjuiceURL", {
                headers: {
                    Authorization: `Bearer ${rootState.accessToken}`,
                },
            }).then((response) => {
                const url = response.data;
                return url
            }).catch((error) => {
                console.log(error)
            });
        },
        async fetchMarketplaceProducts({state}, accountId) {
            return axios.get(state.clientMgmtUrl + `/v1/marketplace/customers/${accountId}/registered_products`, {
                headers: {
                    Authorization: `Bearer ${state.accessToken}`,
                },
            }).then((response) => {
                return response.data;
            }).catch((error) => {
                console.error("Error fetching marketplace products:", error);
                throw error;
            });
        },
        async fetchOnboardStatus({state}, cid) {
            return axios.get(state.clientMgmtUrl + `/v1/clients/${cid}/onboarding_status`, {
                headers: {
                    Authorization: `Bearer ${state.accessToken}`,
                },
            }).then((response) => {
                return response.data;
            }).catch((error) => {
                throw error;
            });
        },
        async fetchRegisteredSKUs({state}, cid) {
            return axios.get(state.clientMgmtUrl + `/v1/clients/${cid}/registered_skus`, {
                headers: {
                    Authorization: `Bearer ${state.accessToken}`,
                },
            }).then((response) => {
                return response.data;
            }).catch((error) => {
                throw error;
            });
        },
    },
    getters: {
        /** Sorted cloud keys from last successful service_deployments fetch (empty if API failed or none). */
        serviceDeploymentClouds(state) {
            return Object.keys(state.endpointsByCloudRegion || {}).sort();
        },
        regionServiceAvailability(state) {
            if (!state.selectedRegion || !Object.keys(state.serviceEndpointsByRegion).length) return {};
            const MANAGED_SERVICES = ['audsum', 'pail', 'surface', 'agents', 'aquacred', 'graph'];
            const regionEndpoints = state.serviceEndpointsByRegion[state.selectedRegion] || {};
            const result = {};
            for (const name of MANAGED_SERVICES) {
                result[name] = !!regionEndpoints[name];
            }
            return result;
        },
        userRoles() {
            const rolesRank = {
                aqfer_admin: 1,
                aqfer_manager: 1.5,
                aqfer_user: 2,
                client_admin: 3,
                client_user: 4,
            };
        
            let currentUserRoles = store.state.currentUser && store.state.currentUser.roles?store.state.currentUser.roles: ["client_user"];    
        
            const isAqferAdmin = currentUserRoles.includes("aqfer_admin")
                                ? true
                                : false;
            const isClientAdmin = currentUserRoles.includes("client_admin")
                                ? true
                                : false;
            const isAqferManager = currentUserRoles.includes("aqfer_manager")
                                ? true
                                : false;
        
            const getRoleRank = (roles) => {
                let rank = 5;
                roles.forEach(function (role) {
                    if (rolesRank[role] < rank) {
                        rank = rolesRank[role];
                    }
                });
                return rank;
            };

            const getUserRole = (roles) => {  
                let rank = 5;
                let highestRole = "client_user";
                roles.forEach(function (role) {
                    if (rolesRank[role] < rank) {
                        rank = rolesRank[role];
                        highestRole = role;
                    }
                });
                return highestRole;
            };

            const isAccessByRole = (accessRoles) => {
                return store.state.currentUser.roles.some(r => accessRoles.indexOf(rolesRank[r]) >= 0);                                
            }
        
            const userRoleRank = getRoleRank(currentUserRoles);
            
            return { isAqferAdmin, isAqferManager, isClientAdmin, getRoleRank, userRoleRank, isAccessByRole, getUserRole };
        }
    },
    modules: {
        admin,
        amdp,
        aut,
        aio,
        sandboxUnitTest,
        sandbox,
        agm,
        usage,
        idr,
        audience

    },
    plugins: [vuexLocal.plugin]
})

export default store